// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"dropdown___37VxL","auto":"auto___2s508","languageMenu":"languageMenu___3TvsH","selectIcon":"selectIcon___3ajYl"};